import { ShopifyShopSystemStrategy } from "./ShopifyShopSystemStrategy";

export class OoniqueShopSystemStrategy extends ShopifyShopSystemStrategy {
  registerEventHandlers(): void {
    const onOffsetChange = async () => {
      const cart = await this.getCart();
      window.dispatchEvent(new CustomEvent("CartReRendered", {}));
      // Re-offset if the cart is changed and we have an offset.
      if (this.getOffsetItem(cart)) {
        // Refresh if this if the offset is the last item in the cart.
        await this.toggleOffset(false, cart!.items.length === 1);
        if (cart!.items.length > 1) await this.toggleOffset(true);
      }
    };
    // This listener is required for Oonique because their sweaters do not fire the cart:change event.
    // TODO: Use this for all events instead of theme events.
    window.addEventListener("cart-add", (ev: Event) => {
      const detail = (
        ev as (Event & { detail: { product_type: string } }) | null
      )?.detail;
      if (!detail) return;
      const shouldReOffset =
        detail.product_type && detail.product_type !== "pina_offset";
      if (shouldReOffset) {
        onOffsetChange();
      }
    });
    // This event is only fired if the user uses the frontend to modify the cart, not by AJAX calls.
    // This avoids an infinite loop (if this were called by offsetting itself).
    // TODO: This is theme dependant.
    document.addEventListener("cart:change", async (ev) => {
      onOffsetChange();
    });
    // Re-render the button if the cart changes in any way.
    const node = document.querySelector("#cart-drawer");
    const observer = new MutationObserver((mutations, observer) => {
      window.dispatchEvent(new CustomEvent("CartReRendered", {}));
    });
    observer.observe(node!, {
      attributes: false,
      childList: true,
      subtree: false,
    });
  }

  async refreshCart(): Promise<void> {
    // TODO: Shopify seemingly does not have a native method to request a cart manually.
    // From what I could find this needs to be done with DOM manipulation.
    // According to the docs the AJAX API can request re-rendered sections as HTML.
    // https://shopify.dev/docs/api/ajax/reference/cart#bundled-section-rendering

    document.dispatchEvent(new CustomEvent("cart:refresh"));
  }
}
